export default function address() {
	return {
		id: undefined,
		name: undefined,
		street: undefined,
		country: undefined,
		postalCode: undefined,
		countryCode: undefined,
		postalPlace: undefined,
		latitude: undefined,
		longitude: undefined,
		contactName: undefined,
		contactPhone: undefined,
		contactEmail: undefined
	};
}
